// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetSpaClaim = () => ({
    type: actions.RESET_TABM_SPA_CLAIM_DETAILS
});



// WEBPACK FOOTER //
// ./src/tabm/spa-details/action-creators/reset-spa-claim.js